// SupporterItem.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SupporterItem = ({ supporter, getRandomGroundPosition }) => {
  const navigate = useNavigate();
  const [showWish, setShowWish] = useState(false);

  useEffect(() => {
    // 0초 ~ 30초 사이 랜덤 딜레이
    const randomDelay = Math.random() * 30000; // ms (0 ~ 30000)
    
    // 말풍선 표시를 위한 타이머
    const timer = setTimeout(() => {
      // 말풍선 보이기
      setShowWish(true);

      // 5초 후 말풍선 숨기기
      const hideTimer = setTimeout(() => {
        setShowWish(false);
      }, 5000);

      // hideTimer 정리
      return () => clearTimeout(hideTimer);
    }, randomDelay);

    // cleanup: timer 정리
    return () => clearTimeout(timer);
  }, []);

  // Supporter 아이콘을 클릭하면 UserSunPage로 이동
  const handleClick = () => {
    navigate(`/userSun/${supporter.uuid}`);
  };

  // return (
  //   <div
  //     className="supporter-info"
  //     style={{
  //       position: 'absolute',
  //       ...getRandomGroundPosition(),
  //       cursor: 'pointer',
  //       textAlign: 'center',
  //     }}
  //     onClick={handleClick}
  //   >
  //     <img
  //       src={`/assets/${supporter.avatar}`}
  //       alt={supporter.username}
  //       className="supporter-avatar"
  //       style={{
  //         width: '30px',
  //         height: '30px',
  //         // borderRadius: '50%',
  //         marginBottom: '5px',
  //       }}
  //     />
  //     <p className="supporter-name" style={{ fontSize: '12px' }}>
  //       {supporter.username}
  //     </p>

  //     {showWish && (
  //       <div
  //         className="wish-bubble"
  //         style={{
  //           position: 'absolute',
  //           bottom: '40px', // 아이콘 기준 위
  //           left: '50%',
  //           transform: 'translateX(-50%)',
  //           backgroundColor: 'white',
  //           border: '1px solid #ccc',
  //           borderRadius: '8px',
  //           padding: '6px',
  //           maxWidth: '120px',
  //           fontSize: '12px',
  //           boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
  //           zIndex: 999,
  //         }}
  //       >
  //         {supporter.newYearSun.wishes[0] || 'No wish set'}
  //       </div>
  //     )}
  //   </div>
  // );
  return (
    <div
      className="supporter-info"
      style={{
        position: 'absolute',
        ...getRandomGroundPosition(),
        cursor: 'pointer',
        textAlign: 'center',
        backgroundColor: 'transparent', // 배경 제거
        padding: 0, // 내부 여백 제거
        border: 'none', // 경계 제거
        boxShadow: 'none', // 그림자 제거
      }}
      onClick={handleClick}
    >
      <img
        src={`/assets/character/${supporter.avatar}`}
        alt={supporter.username}
        className="supporter-avatar"
      />
      <p className="supporter-name" style={{ fontSize: '12px', margin: 0 }}>
        {supporter.username}
      </p>
  
      {showWish && (
        <div
          className="wish-bubble"
        >
          {supporter.newYearSun.wishes[0] || 'No wish set'}
        </div>
      )}
    </div>
  );
};

export default SupporterItem;
